/* =====================================================================
   ENTRE NOS · interacciones del tema
   ===================================================================== */
(function () {
  'use strict';
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Toast ---------- */
  function toast(msg, type) {
    let el = $('#EnToast');
    if (!el) {
      el = document.createElement('div');
      el.id = 'EnToast';
      el.className = 'en-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.dataset.type = type || 'info';
    el.classList.add('is-on');
    clearTimeout(el._t);
    el._t = setTimeout(() => el.classList.remove('is-on'), 3200);
  }
  window.enToast = toast;

  /* ---------- Announcement rotator ---------- */
  function initAnnouncement() {
    $$('[data-en-announce]').forEach((bar) => {
      const msgs = $$('.en-announce__msg', bar);
      if (msgs.length < 2) { msgs[0] && msgs[0].classList.add('is-active'); return; }
      let i = 0;
      msgs[0].classList.add('is-active');
      const speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
      let timer = setInterval(next, speed);
      function next() {
        const cur = msgs[i];
        cur.classList.remove('is-active');
        cur.classList.add('is-leaving');
        setTimeout(() => cur.classList.remove('is-leaving'), 650);
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }
      bar.addEventListener('mouseenter', () => clearInterval(timer));
      bar.addEventListener('mouseleave', () => { clearInterval(timer); timer = setInterval(next, speed); });
    });
  }

  /* ---------- Header ---------- */
  function initHeader() {
    const header = $('[data-en-header]');
    if (!header) return;
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });

    const backdrop = $('.en-mega-backdrop');
    const items = $$('[data-en-dropdown]', header);
    let closeTimer;
    const closeAll = (except) => {
      items.forEach((it) => {
        if (it === except) return;
        it.classList.remove('is-open');
        const t = $('.en-nav__link', it);
        t && t.setAttribute('aria-expanded', 'false');
      });
      if (!except && backdrop) backdrop.classList.remove('is-on');
    };
    const open = (it) => {
      clearTimeout(closeTimer);
      closeAll(it);
      it.classList.add('is-open');
      const t = $('.en-nav__link', it);
      t && t.setAttribute('aria-expanded', 'true');
      if (backdrop && it.hasAttribute('data-en-mega')) backdrop.classList.add('is-on');
      else if (backdrop) backdrop.classList.remove('is-on');
    };
    items.forEach((it) => {
      const link = $('.en-nav__link', it);
      it.addEventListener('mouseenter', () => { clearTimeout(closeTimer); closeTimer = setTimeout(() => open(it), 80); });
      it.addEventListener('mouseleave', () => { clearTimeout(closeTimer); closeTimer = setTimeout(() => closeAll(), 180); });
      it.addEventListener('focusin', () => open(it));
      it.addEventListener('focusout', (e) => { if (!it.contains(e.relatedTarget)) closeAll(); });
      // Touch/click on a large tablet: first tap opens the panel
      link && link.addEventListener('click', (e) => {
        if (window.matchMedia('(hover: none)').matches && !it.classList.contains('is-open')) { e.preventDefault(); open(it); }
      });
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeAll(); });
    backdrop && backdrop.addEventListener('click', () => closeAll());
  }

  /* ---------- Mobile drawer ---------- */
  function initDrawer() {
    const drawer = $('#EnDrawer');
    if (!drawer) return;
    const openers = $$('[data-en-drawer-open]');
    let lastFocus;
    const setOpen = (state) => {
      drawer.classList.toggle('is-open', state);
      drawer.setAttribute('aria-hidden', state ? 'false' : 'true');
      document.body.classList.toggle('en-lock', state);
      openers.forEach((b) => b.setAttribute('aria-expanded', state ? 'true' : 'false'));
      if (state) { lastFocus = document.activeElement; setTimeout(() => { const c = $('.en-drawer__close', drawer); c && c.focus(); }, 60); }
      else if (lastFocus) lastFocus.focus();
    };
    openers.forEach((b) => b.addEventListener('click', () => setOpen(true)));
    $$('[data-en-drawer-close]', drawer).forEach((b) => b.addEventListener('click', () => setOpen(false)));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) setOpen(false); });
    $$('[data-en-acc]', drawer).forEach((btn) => {
      btn.addEventListener('click', () => {
        const panel = document.getElementById(btn.getAttribute('aria-controls'));
        const exp = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', exp ? 'false' : 'true');
        panel && panel.classList.toggle('is-open', !exp);
      });
    });
    $$('a', drawer).forEach((a) => a.addEventListener('click', () => { if (a.getAttribute('href') && a.getAttribute('href').charAt(0) !== '#') setOpen(false); }));
    // search inside drawer
    $$('[data-en-drawer-search]', drawer).forEach((b) => b.addEventListener('click', () => setOpen(false)));
  }

  /* ---------- Add to cart (cards & custom forms) ---------- */
  async function addToCart(id, qty, btn, extra) {
    if (!id) return false;
    btn && btn.classList.add('is-loading');
    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [Object.assign({ id: Number(id), quantity: Number(qty) || 1 }, extra || {})] })
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'No pudimos agregar el producto');
      if (btn) {
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        setTimeout(() => btn.classList.remove('is-added'), 1800);
      }
      // theme.js intercepta /cart/add y abre el carrito; respaldo por si no existe
      setTimeout(() => {
        if (!document.getElementById('CartDrawer') && !/\/cart$/.test(location.pathname)) location.href = root + 'cart';
      }, 400);
      return true;
    } catch (err) {
      btn && btn.classList.remove('is-loading');
      toast(err.message || 'Ocurrió un error, inténtalo de nuevo', 'error');
      return false;
    }
  }
  window.enAddToCart = addToCart;

  function initQuickAdd() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-en-add]');
      if (!btn || btn.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      addToCart(btn.getAttribute('data-en-add'), btn.getAttribute('data-qty') || 1, btn);
    });
  }

  /* ---------- Cart count bump ---------- */
  function initCartBump() {
    $$('#CartCount').forEach((badge) => {
      let last = badge.textContent.trim();
      new MutationObserver(() => {
        const now = badge.textContent.trim();
        if (now !== last) {
          badge.classList.remove('is-bump');
          void badge.offsetWidth;
          badge.classList.add('is-bump');
          last = now;
        }
      }).observe(badge, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    const els = $$('[data-en-reveal]:not(.is-in)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) { els.forEach((el) => el.classList.add('is-in')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -4% 0px', threshold: 0.01 });
    // Lo que ya está en pantalla al cargar se muestra sin esperar
    requestAnimationFrame(() => {
      els.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) { el.classList.add('is-in'); io.unobserve(el); }
      });
    });
    // Respaldo: nunca dejar contenido oculto si el observer no dispara
    setTimeout(() => {
      els.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (!el.classList.contains('is-in') && r.top < window.innerHeight * 1.2) el.classList.add('is-in');
      });
    }, 2500);
    els.forEach((el) => {
      // stagger siblings inside grids
      const parent = el.parentElement;
      if (parent && !el.style.getPropertyValue('--d')) {
        const idx = Array.prototype.indexOf.call(parent.children, el);
        if (idx > 0 && idx < 8) el.style.setProperty('--d', (idx * 0.07).toFixed(2) + 's');
      }
      io.observe(el);
    });
  }
  window.enReveal = initReveal;

  /* ---------- Accordions (details) smooth ---------- */
  function initDetails() {
    $$('details.en-acc').forEach((d) => {
      const sum = $('summary', d);
      const body = $('.en-acc__body', d);
      if (!sum || !body || reduceMotion) return;
      sum.addEventListener('click', (e) => {
        e.preventDefault();
        if (d.open) {
          const h = body.scrollHeight;
          body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 280, easing: 'ease' }).onfinish = () => { d.open = false; };
        } else {
          d.open = true;
          const h = body.scrollHeight;
          body.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 320, easing: 'ease' });
        }
      });
    });
  }

  /* ---------- Card deck ("Saca una carta") ---------- */
  function initDecks() {
    $$('[data-en-deck]').forEach((deck) => {
      let data;
      try { data = JSON.parse($('script[type="application/json"]', deck).textContent); } catch (e) { return; }
      const card = $('.en-deck__card', deck);
      const q = $('.en-deck__q', deck);
      const cat = $('.en-deck__cat', deck);
      const game = $('.en-deck__game', deck);
      const counter = $('.en-deck__count', deck);
      const tabs = $$('[data-deck-mode]', deck);
      let mode = tabs.length ? tabs[0].getAttribute('data-deck-mode') : Object.keys(data)[0];
      let seen = 0;
      const pools = {};
      const pick = () => {
        const list = data[mode] || [];
        if (!list.length) return null;
        if (!pools[mode] || !pools[mode].length) pools[mode] = list.map((_, i) => i).sort(() => Math.random() - 0.5);
        return list[pools[mode].pop()];
      };
      const draw = () => {
        const item = pick();
        if (!item) return;
        card.classList.remove('is-flipped');
        setTimeout(() => {
          q.textContent = item.q;
          cat.textContent = item.cat || '';
          game.textContent = item.game || '';
          card.style.setProperty('--card-c', item.color || '#7724c8');
          card.classList.add('is-flipped');
          seen++;
          if (counter) counter.textContent = seen;
        }, card.classList.contains('is-flipped') ? 260 : 20);
      };
      $$('[data-deck-draw]', deck).forEach((b) => b.addEventListener('click', draw));
      card.addEventListener('click', draw);
      card.addEventListener('keydown', (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); draw(); } });
      tabs.forEach((t) => t.addEventListener('click', () => {
        tabs.forEach((x) => { x.classList.toggle('is-active', x === t); x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        mode = t.getAttribute('data-deck-mode');
        draw();
      }));
    });
  }

  /* ---------- Hero mini card flip ---------- */
  function initHeroCards() {
    $$('[data-en-flipcard]').forEach((el) => {
      let list;
      try { list = JSON.parse(el.getAttribute('data-en-flipcard')); } catch (e) { return; }
      if (!list || list.length < 2) return;
      const txt = $('.en-flip__q', el);
      let i = 0;
      const step = () => {
        el.classList.add('is-turning');
        setTimeout(() => { i = (i + 1) % list.length; txt.textContent = list[i]; el.classList.remove('is-turning'); }, 380);
      };
      let t = setInterval(step, 4200);
      el.addEventListener('click', () => { clearInterval(t); step(); t = setInterval(step, 4200); });
    });
  }

  /* ---------- Quantity steppers ---------- */
  function initQty() {
    document.addEventListener('click', (e) => {
      const b = e.target.closest('[data-en-qty]');
      if (!b) return;
      const wrap = b.closest('.en-qty');
      const input = wrap && $('input', wrap);
      if (!input) return;
      const min = parseInt(input.min, 10) || 1;
      const max = parseInt(input.max, 10) || 99;
      let v = parseInt(input.value, 10) || min;
      v = b.getAttribute('data-en-qty') === 'plus' ? Math.min(max, v + 1) : Math.max(min, v - 1);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ---------- Product page ---------- */
  function initProduct() {
    $$('[data-en-product]').forEach((pdp) => {
      // Gallery
      const main = $('.en-gallery__track', pdp);
      const thumbs = $$('.en-gallery__thumb', pdp);
      const dots = $$('.en-gallery__dot', pdp);
      const slides = main ? $$('.en-gallery__slide', main) : [];
      const setActive = (idx) => {
        thumbs.forEach((t, i) => t.setAttribute('aria-current', i === idx ? 'true' : 'false'));
        dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
        const t = thumbs[idx];
        if (t && t.parentElement && t.parentElement.scrollWidth > t.parentElement.clientWidth) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
      };
      const goTo = (idx) => { if (!main || !slides[idx]) return; main.scrollTo({ left: slides[idx].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' }); setActive(idx); };
      thumbs.forEach((t, i) => t.addEventListener('click', () => goTo(i)));
      dots.forEach((d, i) => d.addEventListener('click', () => goTo(i)));
      $$('[data-gallery-nav]', pdp).forEach((b) => b.addEventListener('click', () => {
        const cur = Math.round(main.scrollLeft / main.clientWidth);
        const next = b.getAttribute('data-gallery-nav') === 'next' ? Math.min(slides.length - 1, cur + 1) : Math.max(0, cur - 1);
        goTo(next);
      }));
      if (main) {
        let st;
        main.addEventListener('scroll', () => { clearTimeout(st); st = setTimeout(() => setActive(Math.round(main.scrollLeft / main.clientWidth)), 60); }, { passive: true });
      }

      // Add to cart form
      const form = $('form[data-en-product-form]', pdp);
      if (form) {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          const btn = $('[data-en-atc]', form);
          const id = $('[name="id"]', form).value;
          const qtyEl = $('[name="quantity"]', form);
          const ok = await addToCart(id, qtyEl ? qtyEl.value : 1, btn);
          if (ok && btn) {
            const label = $('.en-atc__label', btn);
            if (label) { const old = label.textContent; label.textContent = '¡Agregado!'; setTimeout(() => { label.textContent = old; }, 1800); }
          }
        });
      }

      // Sticky add to cart (mobile + desktop)
      const sticky = $('.en-sticky-atc', pdp.closest('.shopify-section') || document);
      const atc = $('[data-en-atc]', pdp);
      if (sticky && atc && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver(([en]) => {
          const past = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-on', past);
          document.body.classList.toggle('en-sticky-on', past);
        }, { threshold: 0 });
        io.observe(atc);
        const sBtn = $('[data-en-sticky-add]', sticky);
        sBtn && sBtn.addEventListener('click', () => {
          const qtyEl = form && $('[name="quantity"]', form);
          addToCart(sBtn.getAttribute('data-en-sticky-add'), qtyEl ? qtyEl.value : 1, sBtn);
        });
      }

      // Share
      $$('[data-en-share]', pdp).forEach((b) => b.addEventListener('click', async () => {
        const url = b.getAttribute('data-url') || location.href;
        if (navigator.share) { try { await navigator.share({ title: document.title, url }); } catch (e) { /* cancel */ } }
        else if (navigator.clipboard) { await navigator.clipboard.writeText(url); toast('¡Enlace copiado!'); }
      }));
    });
  }

  /* ---------- Tabs (generic) ---------- */
  function initTabs() {
    $$('[data-en-tabs]').forEach((wrap) => {
      const btns = $$('[role="tab"]', wrap);
      btns.forEach((b) => b.addEventListener('click', () => {
        btns.forEach((x) => {
          const on = x === b;
          x.setAttribute('aria-selected', on ? 'true' : 'false');
          x.classList.toggle('is-active', on);
          const p = document.getElementById(x.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
        initReveal();
      }));
    });
  }

  /* ---------- Horizontal scroller arrows ---------- */
  function initScrollers() {
    $$('[data-en-scroller]').forEach((wrap) => {
      const track = $('[data-en-track]', wrap);
      if (!track) return;
      const prev = $('[data-en-prev]', wrap);
      const next = $('[data-en-next]', wrap);
      const update = () => {
        if (prev) prev.disabled = track.scrollLeft < 8;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
      };
      const by = () => Math.max(260, track.clientWidth * 0.8);
      prev && prev.addEventListener('click', () => track.scrollBy({ left: -by(), behavior: 'smooth' }));
      next && next.addEventListener('click', () => track.scrollBy({ left: by(), behavior: 'smooth' }));
      track.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function boot() {
    initAnnouncement();
    initHeader();
    initDrawer();
    initQuickAdd();
    initCartBump();
    initReveal();
    initDetails();
    initDecks();
    initHeroCards();
    initQty();
    initProduct();
    initTabs();
    initScrollers();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme editor support
  document.addEventListener('shopify:section:load', () => { initReveal(); initAnnouncement(); initDecks(); initHeroCards(); initProduct(); initTabs(); initScrollers(); initDetails(); });
})();
